import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';
import { Stack } from 'shared/mui/Stack/Stack';

import { BoxStyled } from './GatewaysForm.styled';

const INPUT_HEIGHT = 40;
const CHECKBOX_HEIGHT = 24;
const rowSx = { marginBottom: '24px' };

export const GatewaysFormSkeleton = (): JSX.Element => (
  <Box pt="24px">
    <BoxStyled sx={rowSx}>
      {Array.from({ length: 4 }).map((_, index) => (
        <Skeleton height={INPUT_HEIGHT} key={index} variant="rounded" />
      ))}
    </BoxStyled>
    <BoxStyled sx={rowSx}>
      {Array.from({ length: 3 }).map((_, index) => (
        <Skeleton height={INPUT_HEIGHT} key={index} variant="rounded" />
      ))}
    </BoxStyled>
    <BoxStyled sx={rowSx}>
      {Array.from({ length: 4 }).map((_, index) => (
        <Skeleton height={INPUT_HEIGHT} key={index} variant="rounded" />
      ))}
    </BoxStyled>
    <BoxStyled sx={rowSx}>
      {Array.from({ length: 4 }).map((_, index) => (
        <Skeleton height={INPUT_HEIGHT} key={index} variant="rounded" />
      ))}
    </BoxStyled>
    <Stack direction="row" gap={3} sx={rowSx}>
      {Array.from({ length: 5 }).map((_, index) => (
        <Skeleton height={CHECKBOX_HEIGHT} key={index} variant="rounded" width={200} />
      ))}
    </Stack>
    <Stack direction="row" justifyContent="space-between">
      <Skeleton height={36} variant="rounded" width={116} />
      <Stack direction="row" gap={2}>
        <Skeleton height={36} variant="rounded" width={100} />
        <Skeleton height={36} variant="rounded" width={116} />
      </Stack>
    </Stack>
  </Box>
);
